import { forwardRef } from 'react';

import { ContainerRoot } from './Container.styles';
import type { ContainerProps, VariantType } from './Container.types';

const defaultProps: ContainerProps = {
  alignItems: 'stretch',
  component: 'div',
  flexDirection: 'column',
  variant: 'loose',
  maxWidth: false,
  fullWidth: false,
};

export const Container = forwardRef<HTMLDivElement, ContainerProps>((props, ref) => {
  const {
    alignItems = defaultProps.alignItems,
    component = defaultProps.component,
    flexDirection = defaultProps.flexDirection,
    justifyContent,
    maxWidth = defaultProps.maxWidth,
    variant = defaultProps.variant,
    fullWidth = defaultProps.fullWidth,
    ...otherProps
  } = props;

  return (
    <ContainerRoot
      alignItems={alignItems}
      component={component}
      flexDirection={flexDirection === ('undefined' as unknown) ? defaultProps.flexDirection : flexDirection}
      fullWidth={fullWidth}
      justifyContent={justifyContent}
      maxWidth={maxWidth}
      variant={variant === ('undefined' as VariantType) ? defaultProps.variant : variant}
      {...otherProps}
      ref={ref}
    />
  );
});

Container.displayName = 'Container';
